import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export const normalizeSelections = (values) => [...new Set(
  (Array.isArray(values) ? values : values ? [values] : [])
    .map((v) => String(typeof v === 'object' ? v.value : v).trim())
    .filter(Boolean)
)];

export default function MultiComboboxField({ field, value, options = [], onChange, disabled, error, colors }) {
  const selected = normalizeSelections(value);
  const choices = normalizeSelections(options);
  // options may be [{value, label}]: show the label for a value, typed values as they are
  const labels = new Map((Array.isArray(options) ? options : [])
    .filter((o) => o && typeof o === 'object' && o.label)
    .map((o) => [String(o.value).trim(), String(o.label)]));
  return (
    <Autocomplete
      multiple
      freeSolo
      autoSelect
      filterSelectedOptions
      size="small"
      options={choices}
      getOptionLabel={(v) => labels.get(String(v)) || String(v)}
      value={selected}
      onChange={(_, values) => onChange(field.fieldName, normalizeSelections(values))}
      disabled={disabled}
      sx={{ color: colors.textPrimary }}
      renderInput={(params) => (
        <TextField
          {...params}
          // Enter with text typed adds it as a value instead of moving on (utils/enterAdvance)
          inputProps={{ ...params.inputProps, 'data-multi-value': 'true' }}
          required={!!field.isRequired}
          label={field.displayLabel}
          placeholder="Select or enter a new value"
          error={Boolean(error)}
          helperText={error || field.description}
          sx={{
            '& .MuiInputBase-root': { color: colors.textPrimary },
            '& .MuiFormLabel-root, & .MuiFormHelperText-root': { color: colors.textMuted },
            '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.border },
          }}
        />
      )}
    />
  );
}
